import { CreateCustomerCICReportingReduxState, CustomerCICReportingReducerDispatch, CustomerCICReportingReduxState, CustomerCICReportingReduxTypes } from "./types"

const CUSTOMER_CIC_REPORTING_LIST_INIT_STATE = {
    data: {
        metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
                self: null,
                first: null,
                previous: null,
                next: null,
                last: null
            }
        },
        records: []
    },
    loading: false,
    error: null
}

const CustomerCICReportingIdsReducer = (state: CustomerCICReportingReduxState = CUSTOMER_CIC_REPORTING_LIST_INIT_STATE, action: CustomerCICReportingReducerDispatch) => {
    switch (action.type) {
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTINGS_IDS: {
            return {
                ...state,
                loading: true
            }
        }
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTINGS_IDS_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTINGS_IDS_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            }
        }
        case CustomerCICReportingReduxTypes.RESET_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: false,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                error: false
            }
        }
        default:
            return { ...state };
    }
}

const CustomerCICReportingListReducer = (state: CustomerCICReportingReduxState = CUSTOMER_CIC_REPORTING_LIST_INIT_STATE, action: CustomerCICReportingReducerDispatch) => {
    switch (action.type) {
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTINGS: {
            return {
                ...state,
                loading: true,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTINGS_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTINGS_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            }
        }
        case CustomerCICReportingReduxTypes.RESET_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: false,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                error: false
            }
        }
        default:
            return { ...state };
    }
}
const CustomerCICReportingReducer = (state: CustomerCICReportingReduxState = CUSTOMER_CIC_REPORTING_LIST_INIT_STATE, action: CustomerCICReportingReducerDispatch) => {
    switch (action.type) {
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: true,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            }
        }
        case CustomerCICReportingReduxTypes.RESET_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: false,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                error: false
            }
        }
        default:
            return { ...state };
    }
}

const CUSTOMER_CIC_REPORTING_INIT_STATE = {
    loading: false,
    data: {},
    error: null
}

const CustomerCICReportingVersionReducer = (state: CreateCustomerCICReportingReduxState = CUSTOMER_CIC_REPORTING_INIT_STATE, action: CustomerCICReportingReducerDispatch) => {
    switch (action.type) {
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION: {
            return {
                ...state,
                loading: true,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            }
        }
        case CustomerCICReportingReduxTypes.RESET_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: false,
                data: {},
                error: false
            }
        }
        default:
            return { ...state };
    }
}
const CustomerCICReportingLatestVersionReducer = (state: CreateCustomerCICReportingReduxState = CUSTOMER_CIC_REPORTING_INIT_STATE, action: CustomerCICReportingReducerDispatch) => {
    switch (action.type) {
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_LATEST_VERSION: {
            return {
                ...state,
                loading: true,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_LATEST_VERSION_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_LATEST_VERSION_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            }
        }
        case CustomerCICReportingReduxTypes.RESET_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: false,
                data: {},
                error: false
            }
        }
        default:
            return { ...state };
    }
}
const CustomerCICReportingVersionsDetailReducer = (state: CreateCustomerCICReportingReduxState = CUSTOMER_CIC_REPORTING_INIT_STATE, action: CustomerCICReportingReducerDispatch) => {
    switch (action.type) {
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION_DETAILS: {
            return {
                ...state,
                loading: true,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION_DETAILS_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.FETCH_CUSTOMER_CIC_REPORTING_VERSION_DETAILS_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            }
        }
        case CustomerCICReportingReduxTypes.RESET_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: false,
                data: {},
                error: false
            }
        }
        default:
            return { ...state };
    }
}
const CreateCustomerCICReportingReducer = (state: CreateCustomerCICReportingReduxState = CUSTOMER_CIC_REPORTING_INIT_STATE, action: CustomerCICReportingReducerDispatch) => {
    switch (action.type) {
        case CustomerCICReportingReduxTypes.CREATE_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: true,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.CREATE_CUSTOMER_CIC_REPORTING_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.CREATE_CUSTOMER_CIC_REPORTING_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            }
        }
        case CustomerCICReportingReduxTypes.RESET_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: false,
                data: {},
                error: false
            }
        }
        default:
            return { ...state };
    }
}
const UpdateCustomerCICReportingReducer = (state: CreateCustomerCICReportingReduxState = CUSTOMER_CIC_REPORTING_INIT_STATE, action: CustomerCICReportingReducerDispatch) => {
    switch (action.type) {
        case CustomerCICReportingReduxTypes.UPDATE_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: true,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.UPDATE_CUSTOMER_CIC_REPORTING_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.UPDATE_CUSTOMER_CIC_REPORTING_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            }
        }
        case CustomerCICReportingReduxTypes.RESET_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: false,
                data: {},
                error: false
            }
        }
        default:
            return { ...state };
    }
}
const DeleteCustomerCICReportingReducer = (state: CreateCustomerCICReportingReduxState = CUSTOMER_CIC_REPORTING_INIT_STATE, action: CustomerCICReportingReducerDispatch) => {
    switch (action.type) {
        case CustomerCICReportingReduxTypes.DELETE_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: true,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.DELETE_CUSTOMER_CIC_REPORTING_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.DELETE_CUSTOMER_CIC_REPORTING_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            }
        }
        case CustomerCICReportingReduxTypes.RESET_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: false,
                data: {},
                error: false
            }
        }
        default:
            return { ...state };
    }
}
const ApproveCustomerCICReportingReducer = (state: CreateCustomerCICReportingReduxState = CUSTOMER_CIC_REPORTING_INIT_STATE, action: CustomerCICReportingReducerDispatch) => {
    switch (action.type) {
        case CustomerCICReportingReduxTypes.APPROVE_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: true,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.APPROVE_CUSTOMER_CIC_REPORTING_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.APPROVE_CUSTOMER_CIC_REPORTING_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            }
        }
        case CustomerCICReportingReduxTypes.RESET_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: false,
                data: {},
                error: false
            }
        }
        default:
            return { ...state };
    }
}
const RejectCustomerCICReportingReducer = (state: CreateCustomerCICReportingReduxState = CUSTOMER_CIC_REPORTING_INIT_STATE, action: CustomerCICReportingReducerDispatch) => {
    switch (action.type) {
        case CustomerCICReportingReduxTypes.REJECT_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: true,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.REJECT_CUSTOMER_CIC_REPORTING_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload.data
            }
        }
        case CustomerCICReportingReduxTypes.REJECT_CUSTOMER_CIC_REPORTING_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.payload.error
            }
        }
        case CustomerCICReportingReduxTypes.RESET_CUSTOMER_CIC_REPORTING: {
            return {
                ...state,
                loading: false,
                data: {},
                error: false
            }
        }
        default:
            return { ...state };
    }
}
export {
    CustomerCICReportingIdsReducer,
    CustomerCICReportingListReducer,
    CustomerCICReportingReducer,
    CustomerCICReportingVersionReducer,
    CustomerCICReportingLatestVersionReducer,
    CustomerCICReportingVersionsDetailReducer,
    CreateCustomerCICReportingReducer,
    UpdateCustomerCICReportingReducer,
    DeleteCustomerCICReportingReducer,
    ApproveCustomerCICReportingReducer,
    RejectCustomerCICReportingReducer
}